import { useTranslation, Trans } from "react-i18next";
import { useState } from "react"

import Footer from "../../components/Footer";
import sw1 from '../../img/Products/sw1.png'
import sw2 from '../../img/Products/sw2.png'

import check from '../../img/Products/check.svg'

import Button from '../Button'
import Fade from 'react-reveal/Fade'

import s1 from '../../img/Products/s1.svg'
import s2 from '../../img/Products/s2.svg'
import s3 from '../../img/Products/s3.svg'

import ss1 from '../../img/Products/ss1.svg'
import ss2 from '../../img/Products/ss2.svg'
import ss3 from '../../img/Products/ss3.svg'

import w1 from '../../img/Products/w1.svg'
import w2 from '../../img/Products/w2.svg'
import w3 from '../../img/Products/w3.svg'
import w4 from '../../img/Products/w4.svg'

import e1 from '../../img/Products/e1.png'
import e2 from '../../img/Products/e2.png'
import e3 from '../../img/Products/e3.png'

import t1 from '../../img/Products/t1.png'
import t2 from '../../img/Products/t2.png'

function Switcher() {

  const { t } = useTranslation();

  const [active, setActive] = useState(0)

  const data = [
    {
        title: t('products.4'),
        text1: t('products.9'),
        text2: t('products.10'),
        text3: t('products.11'),
        text4: t('products.12'),
        text5: t('products.13'),
        text6: t('products.14'),
        text7: t('products.15'),
        text8: t('products.16'),
        text9: t('products.17'),
        text10: t('products.18'),
    },
    {
        title: t('products.5'),
        text1: t('products.19'),
        text2: t('products.20'),
        text3: t('products.21'),
        text4: t('products.22'),
        text5: t('products.23'),
        text6: t('products.24'),
        text7: t('products.25'),
        text8: t('products.26'),
        text9: t('products.27'),
        text10: t('products.28'),
    },
    {
        title: t('products.6'),
        text1: t('products.29'),
        text2: t('products.30'),
        text3: t('products.31'),
        text4: t('products.32'),
        text5: t('products.33'),
        text6: t('products.34'),
        text7: t('products.35'),
        text8: t('products.36'),
        text9: t('products.37'),
        text10: t('products.38'),
    },
    {
        title: t('products.7'),
        text1: t('products.39'),
        text2: t('products.40'),
        text3: t('products.41'),
        text4: t('products.42'),
        text5: t('products.43'),
        text6: t('products.44'),
        text7: t('products.45'),
        text8: t('products.46'),
        text9: t('products.47'),
        text10: t('products.48'),
    },
    {
        title: t('products.8'),
        text1: t('products.49'),
        text2: t('products.50'),
        text3: t('products.51'),
        text4: t('products.52'),
        text5: t('products.53'),
        text6: t('products.54'),
        text7: t('products.55'),
        text8: t('products.56'),
        text9: t('products.57'),
        text10: t('products.58'),
    },
  ]

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-wrap gap-[10px] xl:gap-[20px]">
                {data.map((dat, index) =>(
                    <div onClick={()=> setActive(index)} key={index} className={`flex-grow cursor-pointer flex items-center justify-center rounded-[4px] transition-all ${active === index ? 'bg-[#65CDBF]' : 'bg-[#F0FAF9]'}`}>
                        <p className="py-[10px] px-[20px] xl:px-0 xl:py-[18px] poppins font-[500] text-[14px] xl:text-[16px]">{dat.title}</p>
                    </div>
                ))}
            </div>
            <div className="bg-[#0F0229] rounded-[4px] mt-[20px] h-[750px] xl:h-[550px] relative">
                <Fade key={active}>
                    <div className="p-[20px] xl:p-[80px]">
                        <p className="poppins text-[20px] xl:text-[40px] text-[#FFFFFF] leading-[1.2] font-[500] xl:max-w-[700px]">{data[active].text1}</p>
                        <p className="xl:max-w-[497px] mt-[10px] xl:mt-[20px] inter text-[#FFFFFFB2] text-[14px]">{data[active].text2}</p>
                    </div>
                </Fade>
                <div className="xl:absolute mx-[20px] xl:mx-0 left-[80px] bottom-[100px]">
                    <Button/>       
                </div>
                <img src={sw1} className="absolute right-0 bottom-0" alt="" />
                <img src={sw2} className="absolute px-[50px] sm:px-[100px] xl:px-0 xl:right-[140px] bottom-0" alt="" />
            </div>
            <Fade key={active}>
                <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] xl:px-[80px] mt-[20px] xl:mt-[-50px] z-10">
                    <div className="bg-[#F0FAF9] rounded-[4px] p-[20px] xl:w-[250px] xl:h-[196px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M2.7494 2.80949C-0.936389 6.53534 -0.916358 12.5648 2.80949 16.2506C6.53534 19.9364 12.5648 19.9164 16.2506 16.1905C19.9364 12.4647 19.9164 6.43519 16.1905 2.7494C12.4647 -0.936389 6.43519 -0.916358 2.7494 2.80949ZM14.1273 7.67714L8.95915 12.9053C8.51846 13.346 7.79733 13.346 7.35663 12.9053L7.15632 12.705L6.55538 12.1041L4.87273 10.4415C4.43204 10.0008 4.43204 9.27965 4.87273 8.83896C5.31343 8.39827 6.03456 8.39827 6.47525 8.83896L8.15789 10.5016L12.5248 6.09465C12.9654 5.65396 13.6866 5.65396 14.1273 6.09465C14.568 6.51531 14.568 7.23644 14.1273 7.67714Z" fill="#65CDBF"/>
                        </svg>
                        <p className="mt-[20px] leading-[1.2] font-[500] text-[16px] poppins text-[#1A0402]">{data[active].text3}</p>
                        <p className="mt-[20px] leading-[1.5] text-[14px] inter text-[#000000B2]">{data[active].text4}</p>
                    </div>
                    <div className="bg-[#F0FAF9] rounded-[4px] p-[20px] xl:w-[250px] xl:h-[196px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M2.7494 2.80949C-0.936389 6.53534 -0.916358 12.5648 2.80949 16.2506C6.53534 19.9364 12.5648 19.9164 16.2506 16.1905C19.9364 12.4647 19.9164 6.43519 16.1905 2.7494C12.4647 -0.936389 6.43519 -0.916358 2.7494 2.80949ZM14.1273 7.67714L8.95915 12.9053C8.51846 13.346 7.79733 13.346 7.35663 12.9053L7.15632 12.705L6.55538 12.1041L4.87273 10.4415C4.43204 10.0008 4.43204 9.27965 4.87273 8.83896C5.31343 8.39827 6.03456 8.39827 6.47525 8.83896L8.15789 10.5016L12.5248 6.09465C12.9654 5.65396 13.6866 5.65396 14.1273 6.09465C14.568 6.51531 14.568 7.23644 14.1273 7.67714Z" fill="#65CDBF"/>
                        </svg>
                        <p className="mt-[20px] leading-[1.2] font-[500] text-[16px] poppins text-[#1A0402]">{data[active].text5}</p>
                        <p className="mt-[20px] leading-[1.5] text-[14px] inter text-[#000000B2]">{data[active].text6}</p>
                    </div>
                    <div className="bg-[#F0FAF9] rounded-[4px] p-[20px] xl:w-[250px] xl:h-[196px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M2.7494 2.80949C-0.936389 6.53534 -0.916358 12.5648 2.80949 16.2506C6.53534 19.9364 12.5648 19.9164 16.2506 16.1905C19.9364 12.4647 19.9164 6.43519 16.1905 2.7494C12.4647 -0.936389 6.43519 -0.916358 2.7494 2.80949ZM14.1273 7.67714L8.95915 12.9053C8.51846 13.346 7.79733 13.346 7.35663 12.9053L7.15632 12.705L6.55538 12.1041L4.87273 10.4415C4.43204 10.0008 4.43204 9.27965 4.87273 8.83896C5.31343 8.39827 6.03456 8.39827 6.47525 8.83896L8.15789 10.5016L12.5248 6.09465C12.9654 5.65396 13.6866 5.65396 14.1273 6.09465C14.568 6.51531 14.568 7.23644 14.1273 7.67714Z" fill="#65CDBF"/>
                        </svg>
                        <p className="mt-[20px] leading-[1.2] font-[500] text-[16px] poppins text-[#1A0402]">{data[active].text7}</p>
                        <p className="mt-[20px] leading-[1.5] text-[14px] inter text-[#000000B2]">{data[active].text8}</p>
                    </div>
                    <div className="bg-[#F0FAF9] rounded-[4px] p-[20px] xl:w-[250px] xl:h-[196px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M2.7494 2.80949C-0.936389 6.53534 -0.916358 12.5648 2.80949 16.2506C6.53534 19.9364 12.5648 19.9164 16.2506 16.1905C19.9364 12.4647 19.9164 6.43519 16.1905 2.7494C12.4647 -0.936389 6.43519 -0.916358 2.7494 2.80949ZM14.1273 7.67714L8.95915 12.9053C8.51846 13.346 7.79733 13.346 7.35663 12.9053L7.15632 12.705L6.55538 12.1041L4.87273 10.4415C4.43204 10.0008 4.43204 9.27965 4.87273 8.83896C5.31343 8.39827 6.03456 8.39827 6.47525 8.83896L8.15789 10.5016L12.5248 6.09465C12.9654 5.65396 13.6866 5.65396 14.1273 6.09465C14.568 6.51531 14.568 7.23644 14.1273 7.67714Z" fill="#65CDBF"/>
                        </svg>
                        <p className="mt-[20px] leading-[1.2] font-[500] text-[16px] poppins text-[#1A0402]">{data[active].text9}</p>
                        <p className="mt-[20px] leading-[1.5] text-[14px] inter text-[#000000B2]">{data[active].text10}</p>
                    </div>
                </div>
            </Fade>
            
        </div>
        {active === 0 ? 
            <div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.59')}</p>
                    <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[40px]">
                        <div className="flex-grow h-[210px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={s1} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.60')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.61')}</p>
                        </div>
                        <div className="flex-grow h-[210px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={s2} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.62')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.63')}</p>
                        </div>
                        <div className="flex-grow h-[210px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={s3} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.64')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.65')}</p>
                        </div>
                    </div>
                </div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.66')}</p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[70px]">
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.67')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.68')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.69')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.70')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w3} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.71')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.72')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w4} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.73')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.74')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer titleKey="products.75" />
            </div> 
        : null}
        {active === 1 ? 
            <div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.76')}</p>
                    <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[40px]">
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss1} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.77')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.78')}</p>
                        </div>
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss2} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.79')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.80')}</p>
                        </div>
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss3} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.81')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.82')}</p>
                        </div>
                    </div>
                </div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.83')}</p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[70px]">
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.84')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.85')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.86')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.87')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w3} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.88')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.89')}</p>
                            </div>
                        </div>
                        <div className="flex bg-[#F0FAF9] rounded-[4px] gap-[20px] xl:items-center xl:gap-[45px] py-[20px] xl:py-[30px] px-[20px] xl:px-[26px]">
                            <img src={w4} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                            <div>
                                <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.90')}</p>
                                <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[424px]">{t('products.91')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer titleKey="products.92" />
            </div> 
        : null}
        {active === 2 ? 
            <div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.93')}</p>
                     <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[30px] xl:mt-[40px]">
                        <img src={e1} className="rounded-[4px]" alt="" />
                        <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                            <div className="px-[20px] py-[40px]">
                                <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('products.94')}</p>
                                <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('products.95')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col xl:flex-row-reverse gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                        <img src={e2} className="rounded-[4px]" alt="" />
                        <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                            <div className="px-[20px] py-[40px]">
                                <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('products.96')}</p>
                                <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('products.97')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                        <img src={e3} className="rounded-[4px]" alt="" />
                        <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                            <div className="px-[20px] py-[40px]">
                                <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('products.98')}</p>
                                <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('products.99')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col mt-[80px] xl:mt-[140px]">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]"><Trans>{t('products.100')}</Trans></p>
                    <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[40px]">
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss1} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.102')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.103')}</p>
                        </div>
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss2} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.104')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.105')}</p>
                        </div>
                        <div className="flex-grow h-[200px] xl:h-[250px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[40px] py-[20px]">
                            <img src={ss3} alt="" />
                            <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('products.106')}</p>
                            <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('products.107')}</p>
                        </div>
                    </div>
                </div>
                <Footer titleKey="products.108" />
            </div>
        : null}
        {active === 3 ? 
            <div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px] flex flex-col xl:flex-row justify-between gap-[20px]">
                    <div className="xl:max-w-[497px]">
                        <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.109')}</p>
                        <p className="mt-[20px] inter text-[14px] text-[#000000B2]"><Trans>{t('products.110')}</Trans></p>
                    </div>
                    <img src={t1} alt="" />
                </div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px] flex flex-col">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.111')}</p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-[20px] xl:mt-[40px] gap-[20px]">
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.112')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.113')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.114')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.115')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.116')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.117')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.118')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.119')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.120')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.121')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.122')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.123')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.124')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.125')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.126')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.127')}</Trans></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer titleKey="products.128" />
            </div>
        : null}
        {active === 4 ? 
            <div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px] flex flex-col xl:flex-row justify-between gap-[20px]">
                    <div className="xl:max-w-[497px]">
                        <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.129')}</p>
                        <p className="mt-[20px] inter text-[14px] text-[#000000B2]"><Trans>{t('products.130')}</Trans></p>
                    </div>
                    <img src={t1} alt="" />
                </div>
                <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px] flex flex-col">
                    <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('products.131')}</p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-[20px] xl:mt-[40px] gap-[20px]">
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.132')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.133')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.134')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.135')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.136')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.137')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.138')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.139')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.140')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.141')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.142')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.143')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.144')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.145')}</Trans></p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[10px] xl:gap-[60px]">
                            <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                            <div>
                                <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('products.146')}</p>
                                <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('products.147')}</Trans></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer titleKey="products.148" />
            </div>
        : null}
    </div>
  );
}

export default Switcher;
  